import { v4 as uuidv4 } from 'uuid';
import { Tech } from './types';

export const techMock: Tech = {
  id: uuidv4(),
  url: ``,
  title: ``,
  category: [],
  description: {
    description: ``,
  },
  image: {
    title: ``,
    gatsbyImageData: {
      height: 60,
      width: 60,
      layout: `fullWidth`,
      placeholder: {
        fallback: ``,
      },
      images: {
        fallback: {
          sizes: ``,
          src: ``,
          srcSet: ``,
        },
        sources: [
          {
            sizes: ``,
            srcSet: ``,
            type: ``,
          },
        ],
      },
    },
  },
  filler: true,
};
